import type {
  ChatTranscript,
  ChatTranscriptExchange,
} from '@/pocs/chat/export/types'
import type { DeepAChatMessage } from '@/pocs/chat/types'

type ChatTranscriptInput = Omit<ChatTranscript, 'title' | 'exchanges'> & {
  messages: DeepAChatMessage[]
}

function toExchanges(messages: DeepAChatMessage[]): ChatTranscriptExchange[] {
  return messages.flatMap((message, index) => {
    const reply = messages[index + 1]
    if (
      message.role !== 'user' ||
      reply?.role !== 'assistant' ||
      !reply.content
    ) {
      return []
    }
    return [
      {
        question: message.content,
        answer: reply.content,
        isComplete: reply.status === 'finished',
      },
    ]
  })
}

export function createChatTranscript({
  messages,
  ...metadata
}: ChatTranscriptInput): ChatTranscript {
  const exchanges = toExchanges(messages)
  return {
    ...metadata,
    title: exchanges[0]?.question ?? '',
    exchanges,
  }
}

export function formatExportedAt({ exportedAt, locale }: ChatTranscript) {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(exportedAt)
}
